import {Pipe, PipeTransform} from '@angular/core';
import {Permission} from "../model/permission";

@Pipe({
  name: 'hasPermission'
})
export class HasPermissionPipe implements PipeTransform {

  transform(
    permissions: Permission[] | null | undefined,
    keys: string | string[]
  ): boolean {

    if (!permissions?.length) return false;

    const keyList = Array.isArray(keys) ? keys : [keys];

    return permissions.some(p => keyList.includes(p.name));
  }

}
